import React from "react";
import { Download, ShieldCheck, Baby, BadgeCheck } from "lucide-react";

const items = [
  { Icon: Download, label: "Descarga inmediata" },
  { Icon: ShieldCheck, label: "Pago seguro con Hotmart" },
  { Icon: Baby, label: "Ideal para 2 a 6 años" },
  { Icon: BadgeCheck, label: "Garantía de 7 días" },
];

export const TrustBar = () => {
  return (
    <section className="border-y border-[hsl(var(--border))] bg-white" data-testid="trust-bar">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <ul className="grid grid-cols-2 gap-4 py-5 md:grid-cols-4">
          {items.map(({ Icon, label }) => (
            <li
              key={label}
              data-testid="trust-bar-item"
              className="flex items-center justify-center gap-2.5 text-center"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[hsl(var(--brand-mint))]/30">
                <Icon className="h-5 w-5 text-[hsl(var(--brand-coral))]" />
              </span>
              <span className="text-sm font-semibold text-[hsl(var(--brand-ink))]">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
